import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setAdditionalApprovalBySuperRegion, setApprovalHierarchyBySuperRegion, setApprovalHierarchyTableExcel, setIsValidSkipApproval, setSaveApprovalHierarchy, setSaveTitle, setValidateTitle } from 'Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyAction';
import { GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID, GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID, GET_APPROVAL_HIERARCHY_TABLE_EXCEL, GET_IS_VALID_SKIP_APPROVAL, GET_SAVE_APPROVAL_HIERARCHY, GET_SAVE_TITLE, GET_VALIDATE_TITLE } from 'Store/OrderManagement/ApprovalHierarhy/ApprovalHierarhyType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* getApprovalHierarchyBySuperRegionSaga(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/${req?.payload.marketId}/${req?.payload.entityType}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setApprovalHierarchyBySuperRegion(response));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalHierarchyBySuperRegion(null))
        yield put(globalLoaderText(""));
    }
}

function* getAdditionalApprovalBySuperRegionSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/${req?.payload.marketId}/${req?.payload.entityType}?isAdditionalApprover=true`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setAdditionalApprovalBySuperRegion(response));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAdditionalApprovalBySuperRegion(null))
        yield put(globalLoaderText(""));
    }
}

function* getsaveApprovalHierarchySaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy`,
        payload: req.payload
    }
    try {
        yield put(globalLoaderText(`${req?.actionType ?? "Saving"} position....`));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );


        yield put(setSaveApprovalHierarchy({response, isAdditionalApprover: !!req?.payload?.isAdditionalApprover}));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setSaveApprovalHierarchy({response: false, isAdditionalApprover: !!req?.payload?.isAdditionalApprover}))
        yield put(globalLoaderText(""));
    }
}

function* getvalidateTitleSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/validate/${req?.payload}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setValidateTitle(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setValidateTitle(null))
        yield put(globalLoaderText(""));
    }
}

function* getSaveTitleSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/title`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving values...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setSaveTitle(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setSaveTitle(null))
        yield put(globalLoaderText(""));
    }
}

function* getApprovalHierarchyTableExcelSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/excel?entityId=${req?.payload?.entityId}&entityType=${req?.payload?.entityType}&isAdditionalApprover=${req?.isAdditionalApprover || false}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Exporting values...."));
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalHierarchyTableExcel(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setApprovalHierarchyTableExcel(null))
        yield put(globalLoaderText(""));
    }
}

function* getIsValidSkipApprovalSaga(req?: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/validateSkipApproval/${req?.payload}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Validating...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setIsValidSkipApproval(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setIsValidSkipApproval(null))
        yield put(globalLoaderText(""));
    }
}

function* watchApprovalHierarchy() {
    yield takeEvery(GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID, getApprovalHierarchyBySuperRegionSaga);
    yield takeEvery(GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID, getAdditionalApprovalBySuperRegionSaga);
    yield takeEvery(GET_SAVE_APPROVAL_HIERARCHY, getsaveApprovalHierarchySaga);
    yield takeEvery(GET_VALIDATE_TITLE, getvalidateTitleSaga);
    yield takeEvery(GET_SAVE_TITLE, getSaveTitleSaga);
    yield takeEvery(GET_APPROVAL_HIERARCHY_TABLE_EXCEL, getApprovalHierarchyTableExcelSaga);
    yield takeEvery(GET_IS_VALID_SKIP_APPROVAL, getIsValidSkipApprovalSaga);
}

export default function* combinedSaga() {
    yield all([
        watchApprovalHierarchy()
    ])
}
